<script setup>
import { ref } from 'vue'
import UserRoleModal from './UserRoleModal.vue'

const props = defineProps({
  user: {
    type: Object,
    required: true
  }
})

const showRoleModal = ref(false)
</script>

<template>
  <div class="bg-white rounded-lg shadow p-6">
    <div class="flex items-center mb-4">
      <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
        <i class="fas fa-user text-gray-500"></i>
      </div>
      <div class="ml-4">
        <h3 class="font-semibold">{{ user.name }}</h3>
        <p class="text-gray-500 text-sm">{{ user.email }}</p>
      </div>
      <div class="ml-auto">
        <span 
          class="px-2 py-1 rounded-full text-sm"
          :class="user.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'"
        >
          {{ user.status }}
        </span>
      </div>
    </div>
    
    <div class="border-t pt-4">
      <div class="grid grid-cols-2 gap-4">
        <div>
          <p class="text-sm text-gray-500">API Key</p>
          <p class="font-mono text-sm">{{ user.apiKey }}</p>
        </div>
        <div>
          <p class="text-sm text-gray-500">Access Level</p>
          <p class="capitalize">{{ user.accessLevel }}</p>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <p class="text-sm text-gray-500 mb-1">API Usage</p>
      <div class="w-full bg-gray-200 rounded-full h-2">
        <div 
          class="bg-blue-500 h-2 rounded-full"
          :style="{ width: `${(user.quotaUsed / user.quotaLimit) * 100}%` }"
        ></div>
      </div>
      <p class="text-xs text-gray-500 mt-1">
        {{ user.quotaUsed }}/{{ user.quotaLimit }} requests
      </p>
    </div>

    <div class="mt-4 pt-4 border-t">
      <button 
        @click="showRoleModal = true"
        class="w-full px-4 py-2 text-pink-500 border border-pink-500 rounded-lg hover:bg-pink-50"
      >
        Manage Access
      </button>
    </div>

    <UserRoleModal 
      :user="user"
      :show="showRoleModal"
      @close="showRoleModal = false"
      @update="$emit('update')"
    />
  </div>
</template> 